<h2
  class="lg:mt-10 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]"
>
  My Wishlist
</h2>
<label for="sortOrder" class="mx-4">Sort by Price:</label>
<select
  id="sortOrder"
  (change)="onSortOrderChange($event)"
  class="bg-[#7B68EE] h-8 my-auto text-white rounded-md px-1"
>
  <option value="" selected disabled hidden>Sort by Price</option>
  <option value="lowToHigh">Low to High</option>
  <option value="highToLow">High to Low</option>
</select>

<div *ngIf="wishListProduct?.length > 0; else noWishlist">
  <div
    class="lg:grid grid-cols-4 gap-5 sm:grid grid-cols-3 gap-10 xs:grid grid-cols-1 gap-10"
  >
    <div
      class="bg-white dark:bg-white shadow-xl rounded-lg overflow-hidden w-auto h-auto m-3"
      *ngFor="let product of wishListProduct"
    >
      <svg
        viewBox="-2.4 -2.4 28.80 28.80"
        fill="red"
        class="w-12 h-12 rounded-full float-end m-2"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)"
      >
        <g
          id="SVGRepo_bgCarrier"
          stroke-width="0"
          transform="translate(1.5600000000000005,1.5600000000000005), scale(0.87)"
        >
          <rect
            x="-2.4"
            y="-2.4"
            width="28.80"
            height="28.80"
            rx="14.4"
            fill="white"
            stroke-width="0"
          ></rect>
        </g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="white"
          stroke-width="0.672"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z"
            stroke="red"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
        <g id="SVGRepo_iconCarrier">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z"
            stroke="red"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>

      <p
        class="addbtn text-md text-white w-16 mt-2 shadow-lg shadow-purple-400 rounded-r-full"
      >
        {{
          ((product?.product_id?.priceInventoryShippingInfo?.MRP -
            product?.product_id?.priceInventoryShippingInfo?.sellingPrice) /
            product?.product_id?.priceInventoryShippingInfo?.MRP) *
            100 | number : "1.0-0"
        }}% off
      </p>

      <div class="relative rounded">
        <img
          [src]="myWishListImageUrl + product?.product_id?.images[0]"
          alt="Headless UI"
          class="h-52 w-full m-auto object-contain my-auto transform transition duration-500 hover:scale-95"
        />
      </div>

      <div class="m-4">
        <svg
          class="w-4 h-4 mx-px fill-current text-orange-600"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            d="M6.43 12l-2.36 1.64a1 1 0 0 1-1.53-1.11l.83-2.75a1 1 0 0 0-.35-1.09L.73 6.96a1 1 0 0 1 .59-1.8l2.87-.06a1 1 0 0 0 .92-.67l.95-2.71a1 1 0 0 1 1.88 0l.95 2.71c.13.4.5.66.92.67l2.87.06a1 1 0 0 1 .59 1.8l-2.3 1.73a1 1 0 0 0-.34 1.09l.83 2.75a1 1 0 0 1-1.53 1.1L7.57 12a1 1 0 0 0-1.14 0z"
          ></path>
        </svg>
        <p class="text-lg font-bold text-black truncate block capitalize">
          {{ product?.product_id?.productDetails?.productName }}
        </p>
        <div class="flex items-center mb-2">
          <del class="text-red-600">
            <p class="text-sm text-red-600 cursor-auto ml-2">
              ₹
              {{
                product?.product_id?.priceInventoryShippingInfo?.sellingPrice
              }}
            </p>
          </del>
          <p class="text-lg font-semibold text-purple-700 cursor-auto">
            &nbsp;₹
            {{ product?.product_id?.priceInventoryShippingInfo.sellingPrice }}
          </p>
        </div>

        <a
          class="addbtn inline-block hover:bg-indigo-600 text-white p-2 m-1 rounded-lg cursor-pointer"
          (click)="addtocart(product.product_id._id, product.seller_id)"
          >Add To Cart</a
        >
        <a
          class="inline-block text-purple-700 font-semibold p-2 m-1 rounded-lg cursor-pointer"
          (click)="removeWishlist(product?.product_id?._id || product?._id)"
          >Remove</a
        >
      </div>
    </div>
  </div>
</div>

<ng-template #noWishlist>
  <div class="m-auto text-center">
    <div
      class="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-white dark:bg-gray-800 rounded-lg"
    >
      <div
        class="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-white dark:bg-gray-800 rounded-lg"
      >
        <!-- <svg viewBox="0 -1 22 22"class="w-28 h-28 dark:text-gray-400 text-gray-700"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>bag_minus [#1121]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-380.000000, -3159.000000)" fill="#000000"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M346.000448,3018 C346.000448,3018.552 345.552448,3019 345.000448,3019 L341.000448,3019 C340.448448,3019 340.000448,3018.552 340.000448,3018 C340.000448,3017.448 340.448448,3017 341.000448,3017 L345.000448,3017 C345.552448,3017 346.000448,3017.448 346.000448,3018 L346.000448,3018 Z M337.000448,3005 L331.000448,3005 L331.000448,3004 C331.000448,3002.346 332.346448,3001 334.000448,3001 C335.654448,3001 337.000448,3002 337.000448,3004 L337.000448,3005 Z M340.694448,3007.859 L341.714448,3015 L343.734448,3015 L342.551448,3006.717 C342.410448,3005.732 341.566448,3005 340.571448,3005 L339.000448,3005 L339.000448,3004 C339.000448,3001 336.757448,2999 334.000448,2999 C331.243448,2999 329.000448,3001.243 329.000448,3004 L329.000448,3005 L327.735448,3005 C326.739448,3005 325.590448,3005.732 325.449448,3006.717 L324.020448,3016.717 C323.848448,3017.922 324.783448,3019 326.000448,3019 L338.000448,3019 L338.000448,3017 L327.153448,3017 C326.545448,3017 326.077448,3016.461 326.163448,3015.859 L327.306448,3007.859 C327.377448,3007.366 327.799448,3007 328.296448,3007 L329.000448,3007 L329.000448,3009 C329.000448,3009.552 329.448448,3010 330.000448,3010 C330.552448,3010 331.000448,3009.552 331.000448,3009 L331.000448,3007 L337.000448,3007 L337.000448,3009 C337.000448,3009.552 337.448448,3010 338.000448,3010 C338.552448,3010 339.000448,3009.552 339.000448,3009 L339.000448,3007 L339.704448,3007 C340.201448,3007 340.623448,3007.366 340.694448,3007.859 L340.694448,3007.859 Z" id="bag_minus-[#1121]"> </path> </g> </g> </g> </g></svg> -->
        <svg
          viewBox="0 -1 22 22"
          class="w-28 h-28 dark:text-gray-400 text-gray-700"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          fill="#6f6d6d"
          stroke="#6f6d6d"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title>bag_minus [#413e3e]</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="Dribbble-Light-Preview"
                transform="translate(-380.000000, -3159.000000)"
                fill="#837c7c"
              >
                <g id="icons" transform="translate(56.000000, 160.000000)">
                  <path
                    d="M346.000448,3018 C346.000448,3018.552 345.552448,3019 345.000448,3019 L341.000448,3019 C340.448448,3019 340.000448,3018.552 340.000448,3018 C340.000448,3017.448 340.448448,3017 341.000448,3017 L345.000448,3017 C345.552448,3017 346.000448,3017.448 346.000448,3018 L346.000448,3018 Z M337.000448,3005 L331.000448,3005 L331.000448,3004 C331.000448,3002.346 332.346448,3001 334.000448,3001 C335.654448,3001 337.000448,3002 337.000448,3004 L337.000448,3005 Z M340.694448,3007.859 L341.714448,3015 L343.734448,3015 L342.551448,3006.717 C342.410448,3005.732 341.566448,3005 340.571448,3005 L339.000448,3005 L339.000448,3004 C339.000448,3001 336.757448,2999 334.000448,2999 C331.243448,2999 329.000448,3001.243 329.000448,3004 L329.000448,3005 L327.735448,3005 C326.739448,3005 325.590448,3005.732 325.449448,3006.717 L324.020448,3016.717 C323.848448,3017.922 324.783448,3019 326.000448,3019 L338.000448,3019 L338.000448,3017 L327.153448,3017 C326.545448,3017 326.077448,3016.461 326.163448,3015.859 L327.306448,3007.859 C327.377448,3007.366 327.799448,3007 328.296448,3007 L329.000448,3007 L329.000448,3009 C329.000448,3009.552 329.448448,3010 330.000448,3010 C330.552448,3010 331.000448,3009.552 331.000448,3009 L331.000448,3007 L337.000448,3007 L337.000448,3009 C337.000448,3009.552 337.448448,3010 338.000448,3010 C338.552448,3010 339.000448,3009.552 339.000448,3009 L339.000448,3007 L339.704448,3007 C340.201448,3007 340.623448,3007.366 340.694448,3007.859 L340.694448,3007.859 Z"
                    id="bag_minus-[#413e3e]"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <!-- <svg  stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><g id="File_Off"><g><path d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"></path><path d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"></path></g></g></svg> -->
        <h3 class="text-xl font-medium mt-4 text-gray-700 dark:text-gray-200">
          Your Wishlist is empty!
        </h3>
        <p class="text-xs font-medium mt-1 text-purple-700 dark:text-gray-200">
          add item now
        </p>
      </div>
    </div>
  </div>
</ng-template>
